import React from 'react';
import { CardHeader } from '@mui/material';
import { getInitials } from '../../../helpers/initialsExtractor';
import { getPlayerDetails } from '../conneqt.helper';
import { BadgeStatus } from '../conneqt.status';
import { ViewConneqtPayload } from '../../../state/reduxRepositories/conneqt/conneqt.interfaces';
import { Avatar } from '../../../components/avatar/avatar';

interface RequestFromProps {
  conneqt: ViewConneqtPayload;
}
export function RequestFrom({ conneqt }: RequestFromProps) {
  return (
    <CardHeader
      avatar={
        <Avatar
          title={getInitials(
            getPlayerDetails(conneqt.requestPlayerClues)?.name,
          )}
        />
      }
      action={<BadgeStatus testId="conneqtionStatus" status={conneqt.status} />}
      title={conneqt.accountName}
      titleTypographyProps={{ variant: 'subtitle2' }}
    />
  );
}
